function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React, { useRef } from "react";
import { twMerge } from "@stereoagency/tailwind-config";
import { InfoCard } from "../../molecules";
import { Container, EntryAnimation } from "../../atoms";
export default function InfoCardGridSection(param) {
    var _param_variant = param.variant, variant = _param_variant === void 0 ? "default" : _param_variant, cards = param.cards, className = param.className;
    var containerRef = useRef(null);
    return /*#__PURE__*/ React.createElement(Container, {
        ref: containerRef,
        name: InfoCardGridSection.name,
        className: className
    }, /*#__PURE__*/ React.createElement("div", {
        className: twMerge("grid gap-6 grid-flow-row auto-rows-max grid-cols-1 sm:grid-cols-3", variant === "narrow" && "sm:grid-cols-2")
    }, cards.map(function(card, cardIndex) {
        return /*#__PURE__*/ React.createElement(EntryAnimation, {
            key: "card-".concat(card.title),
            view: containerRef,
            delay: (cardIndex + 1) / 10,
            className: "flex"
        }, /*#__PURE__*/ React.createElement(InfoCard, _object_spread_props(_object_spread({}, card), {
            className: "w-full"
        })));
    })));
}

//# sourceMappingURL=InfoCardGridSection.js.map